<template>
  <div class="text-center">
    <v-dialog v-model="showModal" content-class="v-dialog--custom">
      <div class="card h-100 border-0">
        <div class="card-body">
          <div class="row">
            <div class="col color-palette-4 font-weight-bold">
              <span @click="closeModal" class="mr-4" style="cursor: pointer">x</span>
              <span class="ml-4">Cotiza tu propiedad</span>
            </div>
          </div>
          <hr />
          <div class="row">
            <div v-if="model.medias?.full_url" class="col-5">
              <img class="mx-auto d-flex justify-content-center img-card-model" :src="model.medias?.full_url"
                alt="model" />
            </div>
            <div class="col-7 d-flex align-items-center">
              <div>
                <span class="d-block color-palette-4 font-weight-bold">
                  {{ project.name }}
                </span>
                <span class="d-block letter-small">{{ model.property?.total_area }} m<sup>2</sup></span>
                <span class="d-block letter-small">{{ model.property?.bedrooms }} Dormitorios y
                  {{ model.property?.bathrooms }} Baño - {{ model.model }}</span>
                <span class="d-block color-palette-3 font-weight-bold">
                  <span v-if="model.property?.show_price_from">Desde </span> UF {{
                    $formatCurrency(model.property?.price) }}
                </span>
              </div>
            </div>
          </div>
          <form id="form-cotizacion" @submit.prevent="sendQuotationForm" class="row" method="POST" autocomplete="off">
            <input type="hidden" name="_token" :value="csrf" />
            <input type="hidden" name="customer_name" :value="form.name" />
            <input type="hidden" name="customer_phone" :value="form.phone" />
            <input type="hidden" name="customer_rut" :value="form.rut" />
            <input type="hidden" name="customer_salary" :value="form.salary" />
            <input type="hidden" name="customer_email" :value="form.email" />
            <input type="hidden" name="property_id" :value="model.property?.id" />
            <input type="hidden" name="entrada" :value="entrada" />
            <input type="hidden" name="customer_subsidy" :value="form.subsidy" />
            <input type="hidden" name="ds15" :value="form.ds15" />
            <div class="col-12 col-sm-6 py-1">
              <input type="text" placeholder="Nombre Completo" v-model.trim="$v.form.name.$model" :class="!$v.form.name.$anyError
                ? 'form-control letter-small'
                : 'form-control letter-small form-error'
                " />
              <div class="error-data letter-small" v-if="$v.form.name.$dirty">
                <span v-if="!$v.form.name.required">Campo necesario</span>
              </div>
            </div>
            <div class="col-12 col-sm-6 py-1">
              <input type="text" placeholder="RUT" v-rut:live v-model.trim="$v.form.rut.$model" :class="!$v.form.rut.$anyError
                ? 'form-control letter-small'
                : 'form-control letter-small form-error'
                " />
              <div class="error-data letter-small" v-if="$v.form.rut.$dirty">
                <span v-if="!$v.form.rut.rutValidation || !$v.form.rut.minLength">RUT Inválido</span>
              </div>
            </div>
            <div class="col-12 col-sm-6 py-1">
              <input type="text" placeholder="Télefono de contacto" onpaste="return false;"
                v-model.trim="$v.form.phone.$model" maxlength="9" @keypress="onlyNumber" :class="!$v.form.phone.$anyError
                  ? 'form-control letter-small'
                  : 'form-control letter-small form-error'
                  " />
              <div class="error-data letter-small" v-if="$v.form.phone.$dirty">
                <span v-if="!$v.form.phone.required">Campo necesario</span>
                <span v-if="!$v.form.phone.minLength">Teléfono inválido</span>
                <span v-if="!$v.form.phone.maxLength">Teléfono inválido</span>
              </div>
            </div>
            <div class="col-12 col-sm-6 py-1">
              <input type="text" placeholder="Email" v-model.trim="$v.form.email.$model" :class="!$v.form.email.$anyError
                ? 'form-control letter-small'
                : 'form-control letter-small form-error'
                " />
              <div class="error-data letter-small" v-if="$v.form.email.$dirty">
                <span v-if="!$v.form.email.required">Campo necesario</span>
                <span v-if="!$v.form.email.email">Email inválido</span>
              </div>
            </div>
            <div class="col-12 col-sm-6 py-1">
              <v-select-c style="border-radius: 9px !important" v-model="$v.form.salary.$model" :options="salary_ranges"
                label="text" :reduce="(text) => text.id" :class="!$v.form.salary.$anyError ? '' : 'form-error'"
                placeholder="Renta líquida">
              </v-select-c>
              <div class="error-data letter-small" v-if="$v.form.salary.$dirty">
                <span v-if="!$v.form.salary.required">Campo necesario</span>
              </div>
            </div>
            <div class="col-12 col-sm-6 py-1">
              <v-select-c style="border-radius: 9px !important" v-model="$v.form.subsidy.$model"
                :options="subsidy_types" label="text" :reduce="(text) => text.id"
                :class="!$v.form.subsidy.$anyError ? '' : 'form-error'" placeholder="Tipo subsidio">
              </v-select-c>
              <div class="error-data letter-small" v-if="$v.form.subsidy.$dirty">
                <span v-if="!$v.form.subsidy.required">Campo necesario</span>
              </div>
            </div>
            <div class="col-12 col-sm-6 py-1"
              v-if="model.property?.base_subsidie_ds15 > 0 && model.property?.base_subsidies > 0">
              <div class="form-check d-flex align-items-center">
                <input class="form-check-input mt-0" type="checkbox" value="0" v-model="$v.form.ds15.$model">
                <label class="form-check-label">
                  Cotizar con DS15
                </label>
              </div>
            </div>
            <div class="col-12 px-0 my-3">
              <div class="col-12 col-sm-4 ml-auto">
                <button :disabled="formLoading" type="submit"
                  class="btn btn btn-default-solid letter-small float-right btn-block">
                  {{ btnText }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import {
  required,
  minLength,
  email,
  maxLength,
} from "vuelidate/lib/validators";
import { rutValidator, rutInputDirective } from "vue-dni";

import Vue from "vue";
Vue.directive("rut", rutInputDirective);

export default {
  name: "ModalQuote",
  props: {
    project: Object,
    model: [],
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data: () => ({
    csrf: document
      .querySelector('meta[name="csrf-token"]')
      .getAttribute("content"),
    modelSelected: {},
    formLoading: false,
    btnText: "Cotizar",
    form: {
      name: "",
      phone: "",
      rut: "",
      salary: "",
      email: "",
      entrada: "",
      subsidy: "",
      ds15: false,
    },
    salary_ranges: [
      { id: "$400.001 - $800.000", text: "$400.001 - $800.000" },
      { id: "$800.001 - $1.000.000", text: "$800.001 - $1.000.000" },
      { id: "$1.000.001 - $1.300.000", text: "$1.000.001 - $1.300.000" },
      { id: "$1.300.001 - $1.600.000", text: "$1.300.001 - $1.600.000" },
      { id: "$1.600.001 - $2.000.000", text: "$1.600.001 - $2.000.000" },
      { id: "más de $2.000.000", text: "más de $2.000.000" },
    ],
    subsidy_types: [
      { id: "no tengo subsidio", text: "no tengo subsidio" },
      { id: "ds1 tramo 1", text: "ds1 tramo 1" },
      { id: "ds1 tramo 2", text: "ds1 tramo 2" },
      { id: "ds1 tramo 3", text: "ds1 tramo 3" },
      { id: "ds49", text: "ds49" },
      { id: "otro subsidio", text: "otro subsidio" },
    ],
    entrada: localStorage.getItem("entrada"),
  }),
  methods: {
    closeModal() {
      this.$emit("closeModal", false);
    },
    sendQuotationForm() {
      this.$v.form.$touch();
      if (!this.$v.form.$invalid) {
        this.btnText = "Enviando...";
        this.formLoading = true;
        $("#form-cotizacion")
          .attr("action", window.BASE_URL + "/add-quotation")
          .submit();
        setTimeout(() => {
          this.$v.form.$reset();
          this.form = {
            name: "",
            phone: "",
            rut: "",
            salary: "",
            email: "",
            subsidy: "",
            ds15: false,
          };
          this.formLoading = false;
          this.btnText = "Cotizar";
        }, 20000);
      }
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
  },
  computed: {},
  watch: {},
  validations: {
    form: {
      name: {
        required,
      },
      phone: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(9),
      },
      rut: {
        required,
        rutValidation: rutValidator,
        minLength: minLength(9),
      },
      salary: {
        required,
      },
      email: {
        required,
        email,
      },
      subsidy: {
        required,
      },
      ds15: {},
    },
  },
};
</script>

<style scoped>
.letter-small {
  font-size: 0.8rem !important;
}

input {
  height: 2rem !important;
  border-radius: 9px !important;
}

@media (max-width: 639px) {}
</style>